module.exports = __webpack_public_path__ + "static/media/mannequin.39cb4661.jpg";